import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import UserMealEditMeal from './UserMealEditMeal';
import TrackerQuickMealForm from '../../Tracker/QuickMeal/TrackerQuickMealForm';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../../Tracker/helpers/normalizers';
import { normalizeQuickMeal } from '../../Tracker/QuickMeal/helpers';
import { TrackerMealProps } from '../../Tracker/types';

const UserMealDetailsContainer: React.FC<TrackerMealProps> = (props) => {
  sessionStorage.setItem('tracker_depth', '1');

  // Quick-meal template: nutrition inputs instead of an ingredient list and a macro table.
  if (props.trackerMealData.isQuickMeal) {
    return (
      <TrackerQuickMealForm
        key={props.trackerMealData.id}
        mealData={normalizeQuickMeal(props.trackerMealData)}
        editQuickMeal={props.editQuickMeal}
        removeMeal={props.removeMeal}
        date={props.date}
        fromUserMeals
      />
    );
  }

  const normalizedProps = normalizeTrackerMeal(props);
  return <UserMealEditMeal key={normalizedProps.mealData.id} {...normalizedProps} />;
};

export default withLoading(UserMealDetailsContainer, UniversalPlaceholder);
